"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbAccessDeniedPage = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shapes = require("../../skybase-core/shapes");

var _skybaseComponents = require("../../skybase-components");

var _actions = require("../../skybase-components/sb-left-column/actions");

var _sbAccessDeniedPageI18n = require("./sb-access-denied-page-i18n");

var _accessDenied = _interopRequireDefault(require("./access-denied-403.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _SBAccessDeniedPage = /*#__PURE__*/function (_PureComponent) {
  _inherits(_SBAccessDeniedPage, _PureComponent);

  var _super = _createSuper(_SBAccessDeniedPage);

  function _SBAccessDeniedPage() {
    var _this;

    _classCallCheck(this, _SBAccessDeniedPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleGoBack", function () {
      var goBack = _this.props.history.goBack;
      goBack();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnHomepage", function () {
      var _this$props = _this.props,
          homepageUrl = _this$props.homepageUrl,
          push = _this$props.history.push;
      push(homepageUrl);
    });

    _defineProperty(_assertThisInitialized(_this), "hidePanel", function (hide) {
      var handleHideLeftPanel = _this.props.handleHideLeftPanel;
      handleHideLeftPanel(hide);
    });

    return _this;
  }

  _createClass(_SBAccessDeniedPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hideLeftPanel = this.props.hideLeftPanel;

      if (hideLeftPanel) {
        this.hidePanel(true);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.hidePanel(false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _ = _this$props2.intl.formatMessage,
          title = _this$props2.title,
          message = _this$props2.message,
          homepageUrl = _this$props2.homepageUrl,
          length = _this$props2.history.length;

      var pageTitle = title || _(_sbAccessDeniedPageI18n.messages.title);

      return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbFullLayout, {
        title: pageTitle
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-row access-denied-page fl-row fl-justify-sb"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "left"
      }, /*#__PURE__*/_react.default.createElement("h1", null, pageTitle), /*#__PURE__*/_react.default.createElement("p", null, message || _(_sbAccessDeniedPageI18n.messages.accessDenied)), /*#__PURE__*/_react.default.createElement("div", {
        className: "fl-row m-t-30"
      }, length && /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbButton, {
        id: "access-denied-previous-button",
        onClick: this.handleGoBack
      }, _(_sbAccessDeniedPageI18n.messages.previousPage)), homepageUrl && /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbButton, {
        id: "access-denied-homepage-button",
        className: "primary m-l-10",
        onClick: this.handleOnHomepage
      }, _(_sbAccessDeniedPageI18n.messages.homepage)))), /*#__PURE__*/_react.default.createElement("img", {
        className: "error-img",
        src: _accessDenied.default,
        alt: "error-403"
      })));
    }
  }]);

  return _SBAccessDeniedPage;
}(_react.PureComponent);

_defineProperty(_SBAccessDeniedPage, "propTypes", {
  intl: _shapes.intlShape.isRequired,
  title: _propTypes.default.string,
  handleHideLeftPanel: _propTypes.default.func.isRequired,
  message: _propTypes.default.string,
  history: _propTypes.default.shape({
    length: _propTypes.default.number,
    goBack: _propTypes.default.func,
    push: _propTypes.default.func
  }).isRequired,
  homepageUrl: _propTypes.default.string,
  hideLeftPanel: _propTypes.default.bool
});

_defineProperty(_SBAccessDeniedPage, "defaultProps", {
  title: null,
  message: null,
  homepageUrl: '/',
  hideLeftPanel: false
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleHideLeftPanel: function handleHideLeftPanel(hide) {
      return dispatch((0, _actions.hideLeftPanel)(hide));
    }
  };
};

var SbAccessDeniedPage = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(null, mapDispatchToProps)(_SBAccessDeniedPage));
exports.SbAccessDeniedPage = SbAccessDeniedPage;
//# sourceMappingURL=sb-access-denied-page.js.map